import { cn } from "@/lib/utils";

/** The single layout primitive every screen renders inside. Caps content to
 * a phone-sized column and centers it on wider viewports — this app is
 * mobile-only by design, so there's no separate desktop layout to maintain. */
function AppShell({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className="h-dvh w-full overflow-hidden bg-muted/40">
      <div
        className={cn(
          "mx-auto flex h-full w-full max-w-md flex-col overflow-y-auto",
          "pt-[env(safe-area-inset-top)]",
          className,
        )}
        data-slot="app-shell"
        {...props}
      />
    </div>
  );
}

export { AppShell };
